import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin( ScrollToPlugin );
const capabilitySection = document.querySelector( "section#capabilities" );
if ( capabilitySection ) {
  const capItems = document.querySelectorAll( ".capabilities-list li" ),
    capImage = document.querySelector( "#capabilities .cap-content img" ),
    capContent = document.querySelector( "#capabilities .cap-content .body-2" ),
    capIndicator = document.querySelector( "#capabilities .cap-content .indicator" ),
    capButton = document.querySelector( "#capabilities .cap-content .btn a" );
  let idx = 0,
    newtab;
  capItems.forEach( ( item, index ) => {
    item.addEventListener( "click", () => {
      if ( idx == index ) return;
      idx = index;
      capItems.forEach( ( i ) => {
        i.classList.remove( "active" );
        const tab = item.querySelector( ".capabilities-content" );
        tab.style.height = "0px!important";
        tab.style.overflow = "hidden";
      } );

      const heading = caps[ index ].heading;
      const paragraph = caps[ index ].paragraph;
      const image = caps[ index ].image;
      const buttonLink = caps[ index ].buttonLink;
      const buttonText = caps[ index ].buttonText;
      capImage.src = image;
      capContent.innerHTML = paragraph;
      capIndicator.innerHTML = index + 1;
      if ( buttonLink && buttonText ) {
        capButton.innerHTML = buttonText;
        capButton.href = buttonLink;
        capButton.classList.remove( "hidden" );
      } else {
        capButton.classList.add( "hidden" );
      }
      // mobile stuff
      item.classList.add( "active" );
      newtab = capItems[ index ].querySelector( ".capabilities-content" );
      newtab.style.height = newtab.scrollHeight + "px";
      newtab.style.overflow = "visible";

      // Scroll to the opened item on mobile
      if ( window.matchMedia( '(max-width: 1023px)' ).matches ) {
        setTimeout( () => {
          item.scrollIntoView( { behavior: 'smooth', block: 'start' } );
          // Add 30px offset after scroll
          setTimeout( () => {
            window.scrollBy( { top: 30, left: 0, behavior: 'smooth' } );
          }, 210 );
        }, 200 );
      }
      if ( window.matchMedia( '(max-width: 1023px)' ).matches ) {
        const y = item.getBoundingClientRect().top + window.pageYOffset - 30;
        gsap.to( window, { scrollTo: { y, autoKill: true }, duration: 0.6, ease: "power2.inOut" } );
      }
    } );
  } );

}
